<template>
  <div>
    <course-certificate-list
      v-if="showCertificateList"
      :participantWithPass="participantWithPass"
      v-on:showCourse="showCourse"
    ></course-certificate-list>
    <b-card v-else-if="!showExam" title="Kurs obsługi SKP" class="title-inline">
      <b-card-text>
        <h5 class="my-2 font-weight-bold info-text">
          Witamy w Kursie obsługi SKP<sup>®</sup>
        </h5>
      </b-card-text>

      <course-info
        v-if="
          !hasCourseAccess &&
          !(isTestAccountRegistered || isTestAccountUnregistered)
        "
        :styles="styles"
      ></course-info>
      <b-card-text v-else>
        <b-card-text
          >Cieszymy się, że chcesz poszerzyć swoją wiedzę z obsługi programu
          SKP<sup>®</sup>.
        </b-card-text>

        <b-card-text
          >Dzięki informacjom zebranym w Kursie zdobędziesz solidne podstawy do
          pracy z programem, oszczędzisz czas oraz zyskasz cenne wskazówki i
          podpowiedzi naszych ekspertów, które zagwarantują szybkie rozpoczęcie
          wykorzystywania potencjału SKP<sup>®</sup>. Szkolenie jest adresowane
          zarówno do Użytkowników
          <strong
            >dopiero rozpoczynających pracę z programem SKP<sup>®</sup></strong
          >, jak i tych, którzy
          <strong>pracują w programie już od jakiegoś czasu</strong>, ale pragną
          usystematyzować i pogłębić swoją wiedzę.
          <a
            href="https://www.ksiega-podatkowa.pl/kurs-obslugi-programu-skp/o-kursie"
            target="_blank"
            >Więcej o kursie></a
          ><br />
          Dostęp do Kursu ważny do 31.12.{{ currentYear }} r.
        </b-card-text>
        <hr class="mb-3" />

        <b-card>
          <p class="my-2 font-weight-bold info-text">
            <img
              src="/assets/images/icons/play-icon.png"
              title="Rozpocznij kurs"
              alt=""
            />
            ROZPOCZNIJ KURS:
          </p>
          <div class="my-1">
            <div class="row">
              <div class="col-lg-6">
                <span class="color-black pr-1">(00:20:10)</span>
                <a :href="getCourseUrl(1, 'wprowadzenie')" target="_blank">
                  MODUŁ I. WPROWADZENIE</a
                >
              </div>
              <div class="col-lg-6">
                <a
                  href="/pdf/kurs/Akademia SKP® - certyfikowany kurs obsługi programu SKP®. Moduł 1 - Wprowadzenie.pdf"
                  target="_blank"
                  class="font-italic -underline color-black"
                  >Pobierz PDF i wydrukuj ></a
                >
              </div>
            </div>
          </div>

          <div class="my-1">
            <div class="row">
              <div class="col-lg-6">
                <span class="color-black pr-1">(00:91:00)</span>
                <a :href="getCourseUrl(2, 'konfiguracja')" target="_blank">
                  MODUŁ II. KONFIGURACJA PROGRAMU SKP<sup>®</sup></a
                >
              </div>
              <div class="col-lg-6">
                <a
                  href="/pdf/kurs/Akademia SKP® - certyfikowany kurs obsługi programu SKP®. Moduł 2 - konfiguracja programu.pdf"
                  target="_blank"
                  class="font-italic -underline color-black"
                  >Pobierz PDF i wydrukuj ></a
                >
              </div>
            </div>
          </div>

          <div class="my-1">
            <div class="row">
              <div class="col-lg-6">
                <span class="color-black pr-1">(00:60:36)</span>
                <a :href="getCourseUrl(3, 'fakturowanie')" target="_blank">
                  MODUŁ III. FAKTUROWANIE</a
                >
              </div>
              <div class="col-lg-6">
                <a
                  href="/pdf/kurs/Akademia SKP® - certyfikowany kurs obsługi programu SKP®. Moduł 3 - Fakturowanie.pdf"
                  target="_blank"
                  class="font-italic -underline color-black"
                  >Pobierz PDF i wydrukuj ></a
                >
              </div>
            </div>
          </div>

          <div class="my-1">
            <div class="row">
              <div class="col-lg-6">
                <span class="color-black pr-1">(00:26:39)</span>
                <a :href="getCourseUrl(4, 'minimagazyn')" target="_blank">
                  MODUŁ IV. MINIMAGAZYN</a
                >
              </div>
              <div class="col-lg-6">
                <a
                  href="/pdf/kurs/Akademia SKP® - certyfikowany kurs obsługi programu SKP®. Moduł 4 - Minimagazyn.pdf"
                  target="_blank"
                  class="font-italic -underline color-black"
                  >Pobierz PDF i wydrukuj ></a
                >
              </div>
            </div>
          </div>

          <div class="my-1">
            <div class="row">
              <div class="col-lg-6">
                <span class="color-black pr-1">(01:46:58)</span>
                <a :href="getCourseUrl(5, 'ksiegowanie')" target="_blank">
                  MODUŁ V. KSIĘGOWANIE</a
                >
              </div>
              <div class="col-lg-6">
                <a
                  href="/pdf/kurs/Akademia SKP® - certyfikowany kurs obsługi programu SKP®. Moduł 5 - Księgowanie.pdf"
                  target="_blank"
                  class="font-italic -underline color-black"
                  >Pobierz PDF i wydrukuj ></a
                >
              </div>
            </div>
          </div>

          <div class="my-1">
            <div class="row">
              <div class="col-lg-6">
                <span class="color-black pr-1">(01:08:44)</span>
                <a
                  :href="getCourseUrl(6, 'ksiega-podatek-dochodowy')"
                  target="_blank"
                >
                  MODUŁ VI. KSIĘGA PODATKOWA I PODATEK DOCHODOWY</a
                >
              </div>
              <div class="col-lg-6">
                <a
                  href="/pdf/kurs/Akademia SKP® - certyfikowany kurs obsługi programu SKP®. Moduł 6 - Księga Podatkowa i Podatek Dochodowy.pdf"
                  target="_blank"
                  class="font-italic -underline color-black"
                  >Pobierz PDF i wydrukuj ></a
                >
              </div>
            </div>
          </div>

          <div class="my-1">
            <div class="row">
              <div class="col-lg-6">
                <span class="color-black pr-1">(00:35:25)</span>
                <a :href="getCourseUrl(7, 'ryczalt')" target="_blank">
                  MODUŁ VII. RYCZAŁT EWIDENCJONOWANY</a
                >
              </div>
              <div class="col-lg-6">
                <a
                  href="/pdf/kurs/Akademia SKP® - certyfikowany kurs obsługi programu SKP®. Moduł 7- Ryczałt ewidencjonowany.pdf"
                  target="_blank"
                  class="font-italic -underline color-black"
                  >Pobierz PDF i wydrukuj ></a
                >
              </div>
            </div>
          </div>

          <div class="my-1">
            <div class="row">
              <div class="col-lg-6">
                <span class="color-black pr-1">(01:43:38)</span>
                <a :href="getCourseUrl(8, 'podatek-vat')" target="_blank">
                  MODUŁ VIII. PODATEK VAT</a
                >
              </div>
              <div class="col-lg-6">
                <a
                  href="/pdf/kurs/Akademia SKP® - certyfikowany kurs obsługi programu SKP®. Moduł 8- Podatek VAT.pdf"
                  target="_blank"
                  class="font-italic -underline color-black"
                  >Pobierz PDF i wydrukuj ></a
                >
              </div>
            </div>
          </div>

          <div class="my-1">
            <div class="row">
              <div class="col-lg-6">
                <span class="color-black pr-1">(01:28:30)</span>
                <a
                  :href="getCourseUrl(9, 'srodki-trwale-wyposazenie')"
                  target="_blank"
                >
                  MODUŁ IX. ŚRODKI TRWAŁE I WYPOSAŻENIE</a
                >
              </div>
              <div class="col-lg-6">
                <a
                  href="/pdf/kurs/Akademia SKP® - certyfikowany kurs obsługi programu SKP®. Moduł 9 - Środki trwałe.pdf"
                  target="_blank"
                  class="font-italic -underline color-black"
                  >Pobierz PDF i wydrukuj ></a
                >
              </div>
            </div>
          </div>

          <div class="my-1">
            <div class="row">
              <div class="col-lg-6">
                <span class="color-black pr-1">(00:46:24)</span>
                <a
                  :href="getCourseUrl(10, 'ewidencja-samochodow')"
                  target="_blank"
                >
                  MODUŁ X. EWIDENCJA SAMOCHODÓW I ROZLICZENIE</a
                >
              </div>
              <div class="col-lg-6">
                <a
                  href="/pdf/kurs/Akademia SKP® - certyfikowany kurs obsługi programu SKP®. Moduł 10- Ewidencja samochodów i rozliczenie pojazdów.pdf"
                  target="_blank"
                  class="font-italic -underline color-black"
                  >Pobierz PDF i wydrukuj ></a
                >
              </div>
            </div>
          </div>

          <div class="my-1">
            <div class="row">
              <div class="col-lg-6">
                <span class="color-black pr-1">(00:31:50)</span>
                <a :href="getCourseUrl(11, 'delegacje')" target="_blank">
                  MODUŁ XI. DELEGACJE KRAJOWE I ZAGRANICZNE</a
                >
              </div>
              <div class="col-lg-6">
                <a
                  href="/pdf/kurs/Akademia SKP® - certyfikowany kurs obsługi programu SKP®. Moduł 11- Delegacje krajowe i zagraniczne.pdf"
                  target="_blank"
                  class="font-italic -underline color-black"
                  >Pobierz PDF i wydrukuj ></a
                >
              </div>
            </div>
          </div>

          <div class="my-1">
            <div class="row">
              <div class="col-lg-6">
                <span class="color-black pr-1">(00:27:00)</span>
                <a
                  :href="getCourseUrl(12, 'place-zus-wlasciciel')"
                  target="_blank"
                >
                  MODUŁ XII. PŁACE I ZUS  – WŁAŚCICIEL</a
                >
              </div>
              <div class="col-lg-6">
                <a
                  href="/pdf/kurs/Akademia SKP® - certyfikowany kurs obsługi programu SKP®. Moduł 12- ZUS Właścicielski.pdf"
                  target="_blank"
                  class="font-italic -underline color-black"
                  >Pobierz PDF i wydrukuj ></a
                >
              </div>
            </div>
          </div>

          <div class="my-1">
            <div class="row">
              <div class="col-lg-6">
                <span class="color-black pr-1">(01:39:12)</span>
                <a
                  :href="getCourseUrl(13, 'place-zus-pracownicy')"
                  target="_blank"
                >
                  MODUŁ XIII. PŁACE I ZUS – PRACOWNICY</a
                >
              </div>
              <div class="col-lg-6">
                <a
                  href="/pdf/kurs/Akademia SKP® - certyfikowany kurs obsługi programu SKP®. Moduł 13 - Rozliczenie pracowników.pdf"
                  target="_blank"
                  class="font-italic -underline color-black"
                  >Pobierz PDF i wydrukuj ></a
                >
              </div>
            </div>
          </div>

          <div class="my-1">
            <div class="row">
              <div class="col-lg-6">
                <span class="color-black pr-1">(01:17:27)</span>
                <a :href="getCourseUrl(14, 'ewidencje-druki')" target="_blank">
                  MODUŁ XIV. PŁACE I ZUS – EWIDENCJE I INNE DRUKI</a
                >
              </div>
              <div class="col-lg-6">
                <a
                  href="/pdf/kurs/Akademia SKP® - certyfikowany kurs obsługi programu SKP®. Moduł 14 - Lista Płac, deklaracje i inne druki.pdf"
                  target="_blank"
                  class="font-italic -underline color-black"
                  >Pobierz PDF i wydrukuj ></a
                >
              </div>
            </div>
          </div>

          <div class="my-1">
            <div class="row">
              <div class="col-lg-6">
                <span class="color-black pr-1">(00:05:00)</span>
                <a
                  :href="getCourseUrl(15, 'uzytkowanie-opieka-wsparcie')"
                  target="_blank"
                >
                  MODUŁ XV. UŻYTKOWANIE PROGRAMU, OPIEKA SERWISOWA I WSPARCIE</a
                >
              </div>
              <div class="col-lg-6">
                <a
                  href="/pdf/kurs/Akademia SKP® - certyfikowany kurs obsługi programu SKP®. Moduł 15 - Użytkowanie programu Opieka Serwisowa i wsparcie.pdf"
                  target="_blank"
                  class="font-italic -underline color-black"
                  >Pobierz PDF i wydrukuj ></a
                >
              </div>
            </div>
          </div>
        </b-card>

        <b-card-text>
          Uwaga: W przypadku wyboru: "Pobierz PDF i wydrukuj", w celu uzyskania
          lepszej czytelności wydruku, należy w ustawieniach drukarki wybrać:
          Skala niestandardowa i ustawić na 150%.
        </b-card-text>
        <hr class="mb-3" />

        <div v-if="!isTestAccountRegistered && !isTestAccountUnregistered">
          <b-card-text>
            <p class="my-2 font-weight-bold info-text">UZYSKAJ CERTYFIKAT:</p>

            Po zakończonym kursie przystąp do testu końcowego! Jeżeli jego wynik
            będzie pozytywny, otrzymasz od Akademii SKP<sup>®</sup>
            <strong
              >imienny Certyfikat ukończenia kursu znajomości i obsługi programu
              SKP<sup>®</sup></strong
            >.
          </b-card-text>

          <b-row
            v-if="!isTestAccountRegistered && !isTestAccountUnregistered"
            class="mb-3"
          >
            <b-col :lg="certificateColClass" class="text-center">
              <b-button
                class="btn-outline-white"
                variant="outline-light"
                v-on:click="onBtnStartExam"
              >
                <div class="nav-link nav-link--btn">
                  <div class="d-inline-block">
                    <img
                      :src="styles.course_test_sm"
                      alt=""
                      class="position-relative"
                    />
                  </div>
                  <div class="ml-2 d-inline-block">
                    Przystąp do testu końcowego i zdobądź Certyfikat
                    <b-icon-chevron-right class="font-size-15" />
                  </div>
                </div>
              </b-button>
            </b-col>

            <b-col
              lg="6"
              class="text-center mt-sm-2 mt-lg-0"
              v-if="participantWithPass.length > 0"
            >
              <b-button
                class="btn-outline-white"
                variant="outline-light"
                v-on:click="
                  showCertificateList = true;
                  showExam = false;
                "
              >
                <div class="nav-link nav-link--btn">
                  <div class="ml-2 d-inline-block">
                    <img :src="styles.course_dyplom_sm" alt="" class="" />
                  </div>
                  <div class="ml-2 d-inline-block">
                    Twoje Certyfikaty- zobacz
                    <b-icon-chevron-right class="font-size-15" />
                  </div>
                </div>
              </b-button>
            </b-col>
          </b-row>

          <b-card-text class="text-uppercase">
            <strong>Dlaczego warto zdobyć Certyfikat:</strong>
          </b-card-text>
          <b-row
            v-if="!isTestAccountRegistered && !isTestAccountUnregistered"
            class="mb-3"
          >
            <b-col lg="6">
              <b-card class="">
                <b-card-header
                  class="info-text text-center font-weight-bold bg-none mb-2"
                  >Dla pracownika:
                </b-card-header>
                <ul>
                  <li>
                    potwierdzi Twoją umiejętność efektywnej obsługi programu;
                  </li>
                  <li>
                    poświadczy biegłość w dostosowaniu działania każdego modułu
                    SKP® do własnych wymagań;
                  </li>
                  <li>podniesie Twoje kompetencje zawodowe;</li>
                  <li>
                    ukończeniem kursu i zdobyciem Certyfikatu możesz pochwalić
                    się w CV.<br /><br />
                  </li>
                </ul>
              </b-card>
            </b-col>
            <b-col lg="6">
              <b-card class="">
                <b-card-header
                  class="info-text text-center font-weight-bold bg-none mb-2"
                  >Dla pracodawcy:
                </b-card-header>
                <ul>
                  <li>
                    wykaże kompetencje pracowników w zastosowaniu praktycznych
                    operacji i rozwiązań zawartych w programie;
                  </li>
                  <li>
                    pozwoli zweryfikować, jaki poziom wiedzy z obsługi i
                    znajomości SKP® posiada Twój pracownik lub kandydat
                    ubiegający się o pracę;
                  </li>
                  <li>
                    umożliwi efektywne i bezpłatne przeszkolenie
                    nowozatrudnionego pracownika z obsługi SKP®.
                  </li>
                </ul>
              </b-card>
            </b-col>
          </b-row>
        </div>
        <b-card-text class="pb-3">
          Niniejszy Kurs Obsługi SKP® został przygotowany wg. stanu prawnego na
          dzień 31.12.2021 r. i będzie cyklicznie dostosowywany do bieżących
          przepisów, w tym Polskiego Ładu.<br />
          <a
            href="https://docs.format.wroc.pl/skp/Regulamin_korzystania_z_bezplatnego_Kursu_obslugi_SKP.pdf"
            target="_blank"
            >Regulamin promocji ></a
          >
        </b-card-text>
      </b-card-text>
    </b-card>
    <course-exam
      v-else-if="showExam"
      :styles="styles"
      v-on:showCourse="showCourse"
    ></course-exam>
  </div>
</template>

<script>
import CourseInfo from './CourseInfo';
import CourseExam from './partials/course-exam/CourseExam';
import CourseCertificateList from './partials/course-exam/CourseCertificateList';
import { mapGetters } from 'vuex';

export default {
  name: 'Course',
  components: { CourseExam, CourseInfo, CourseCertificateList },
  data() {
    return {
      showExam: false,
      showCertificateList: false,
      participants: {},
      participantWithPass: {},
      currentYear: new Date().getFullYear(),
    };
  },
  props: {
    styles: {},
  },
  computed: {
    ...mapGetters({
      isTestAccountRegistered: 'auth/isTestAccountRegistered',
      isTestAccountUnregistered: 'auth/isTestAccountunRegistered',
      hasCourseAccess: 'auth/hasCourseAccess',
      licence: 'auth/userLicence',
    }),
    certificateColClass() {
      return this.participantWithPass.length > 0 ? '6' : '12';
    },
  },
  created() {
    this.getSavedParticipant();
  },
  methods: {
    getCourseUrl(course, title) {
      return process.env.MIX_COURSE_URL + 'kurs/' + course + '/' + title;
    },
    showCourse() {
      this.showCertificateList = false;
      this.showExam = false;
    },
    getSavedParticipant() {
      axios
        .post('/api/course-exam/get-saved-participant-names')
        .then(({ data }) => {
          this.participants = data;
          this.participantWithPass = data.filter(
            (item) => item.exam_pass === 1
          );
        })
        .catch((error) => {});
    },
    onBtnStartExam() {
      window.dataLayer.push({
        event: 'btnPrzystapDoTestu',
        license_id: this.licence,
      });
      this.showExam = true;
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
::v-deep {
  .nav-link {
    &--btn {
      color: #3490dc;
    }
  }
}
</style>
